import { render, staticRenderFns } from "./Manager.vue?vue&type=template&id=26d13ad2&scoped=true"
import script from "./Manager.vue?vue&type=script&lang=ts"
export * from "./Manager.vue?vue&type=script&lang=ts"
import style0 from "./Manager.vue?vue&type=style&index=0&id=26d13ad2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26d13ad2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAlert,VContainer,VFlex,VLayout})
